<template>
    <div class="">     
        <div v-if="reg_custom_list.length>0">

        <div class="card-header px-0 bg-transparent border-0">
            <div class="row no-margin">
                <div class="col-sm-6 pl-0" >                
                    <div class="employee-btn-holder" style="max-width:210px" v-if="$acl['gf-employee-registration'] > 1">
                        <div class="report-intro" style="text-align:center">
                            Bulk Import 
                        </div>  
                        <div  style="min-height:5px;">

                        </div>   
                        <b-button @click="exportGFSelected" ><b-icon icon="code-slash" ></b-icon> Template</b-button>
                        <b-button :href="$api_url+'/gf/employee/import/add'"><b-icon icon="box-arrow-up" class="" scale="1"></b-icon> Import</b-button>                    

                    </div>
                </div> 
            </div>
        </div>
            <common-list  :pageurl="this.$api_url"  :checkbox="checkbox" :is_action="reg_is_action" :is_pf="is_n_gf" :appended_column="reg_appended_column" :key="reg_list_key" :company_options="reg_company_options" :employees="reg_custom_list" :default_column="reg_default_column" :primary_key="reg_primary_key" v-on:childToParent="reg_listReturn"></common-list>
        </div>
        <div v-else>

            <div v-if="show_loader_3" class="list-no-data">
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
            </div>
        <div v-else class="list-no-data">
            Looks like there is no employee to show.
        </div>

        </div>

        <b-modal size="md" id="bv-modal-register-gf" hide-footer :title="'Register GF for '+curr_emp_name">
            <div class="d-block">
                <div class="row no-margin px-0">
                    <div class="col-md-12">
                        <div class="ibox-content pf-overview px-0 pb-0">
                            <div class="payslip-details-info-inner row">
                                <template >
                                    <div class="col-md-4 payslip-details-info-right">
                                        <div class="wrapper">
                                            <div class="first">Employee Code</div>
                                            <div class="second"> {{ gf_profile_data.employee_code }} </div>
                                        </div>
                                    </div>
                                    
                                    <div class="col-md-4 payslip-details-info-right">
                                        <div class="wrapper">
                                            <div class="first">Employee Name</div>
                                            <div class="second"> {{ gf_profile_data.name }}</div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 payslip-details-info-right">
                                        <div class="wrapper">
                                            <div class="first">Job Position</div>
                                            <div class="second"> {{ gf_profile_data.jobposition }} </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 payslip-details-info-right">
                                        <div class="wrapper">
                                            <div class="first">Joining Date</div>
                                            <div class="second"> {{ gf_profile_data.joining_date }} </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 payslip-details-info-right">
                                        <div class="wrapper">
                                            <div class="first">Department</div>
                                            <div class="second">{{ gf_profile_data.department }}</div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 payslip-details-info-right">
                                    
                                        <div class="wrapper">
                                            <div class="first">Work Location</div>
                                            
                                            <div class="second">{{ formatMoney(gf_profile_data.branch) }}</div>
                                        </div>
                                    </div>
                                    
                                    <div class="col-md-4 payslip-details-info-right">
                                        <div class="wrapper">
                                            <div class="first">Leaving Date</div>
                                            <div class="second">{{ gf_profile_data.leaving_date }}</div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div> 
                    </div>
                </div>
                <b-form @submit.stop.prevent="addEmployeeToGf">                    
                    <div class="clearfix mt-4">                                         
                        <div class="row clearfix no-margin">
                            <div class="col-md-12">                                         
                                <b-form-group id="gf_approve_date-group" label="Confirmation Date [YYYY-MM-DD]" class="required-field" label-for="gf_approve_date">
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-form-datepicker id="gf_approve_date_picker" button-only right locale="en-US" v-model="gf_approve_date" :min="min_date"  ></b-form-datepicker>
                                        </b-input-group-prepend>
                                        <b-form-input id="gf_approve_date" name="gf_approve_date" v-model="gf_approve_date"  type="text" placeholder="YYYY-MM-DD" autocomplete="off" v-validate="{ required: true }"  aria-describedby="gf_approve_date-feedback" data-vv-as="Confirmation Date"></b-form-input>
                                        <!-- <b-form-invalid-feedback id="settlement_date-feedback">{{ veeErrors.first('settlement_date') }}</b-form-invalid-feedback> -->
                                    </b-input-group>
                                </b-form-group>
                            </div> 
                            <div class="mt-4 col-md-12 mb-4 pb-3 clearfix" style="margin-right: 0;">
                                <b-button class="border rounded bg-light float-right py-1 px-5" type="submit" variant="primary">Submit</b-button>
                            </div>
                        </div>                           
                    </div>
                </b-form> 
            </div>
        </b-modal>

    </div>
</template>
<script>
export default{
        mounted() {
            //if(this.employeedata.last_working_day == '0000-00-00')
                //this.fdata.last_working_day = '';
            
            this.showoverlay = false;
        },
        components: {
        },
        data(){            
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const minDate = new Date(today);
            return {
                     
    
                showoverlay : true,
                gf_start_date : '',
                errormsg:[],
                checkbox:1, 
                show_loader_3:true,    
                application_loading : false,
                employeesearch:{name:'',status:1},
                users : [], 
                em_tmp_custom_list:[],
                chosen_emp_id: 0,
                curr_emp_name: '',
                gf_approve_date: '',

                /**Child Component property data */

                is_n_gf:1,
                reg_is_action:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                reg_list_key:0, /* Component Key */
                reg_custom_list:[],  /* Data List */
                reg_default_column:['name','email','jobposition','branch'], /* Default Column List */
                reg_appended_column:[],                   /* Appended Column List  and there title and type */
                reg_primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                reg_company_options:[],         /* Company Filterable options */
                reg_tmp_custom_list:[],
                gf_profile_data:[],
                min_date:minDate,

                
            }
        },
        methods:{
        download_file(fileURL) 
        {
            if(!this.checkNet()) return false;
            
            var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
            if (!window.ActiveXObject) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                save.download = fileName || filename;
                if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                        document.location = save.href;
                    }else{
                        var evt = new MouseEvent('click', {
                            'view': window,
                            'bubbles': true,
                            'cancelable': false
                        });
                        save.dispatchEvent(evt);
                        (window.URL || window.webkitURL).revokeObjectURL(save.href);
                    }    
            }
            else if ( !! window.ActiveXObject && document.execCommand)     {
                var _window = window.open(fileURL, '_blank');
                _window.document.close();
                _window.document.execCommand('SaveAs', true, fileName || fileURL)
                _window.close();
            }
        },


        exportGFSelected: function()
        {
            if(this.selected == '')
            this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
            else
            {
                this.exportGF('selected');
            }

        },
        
        exportGF: function(sltd='')
        {
            let currentObj = this;
            
            this.$bvToast.toast('It might take a while', {
                                    title: `Info`, 
                                    variant: 'info',
                                    solid: true
                                });
            console.log(this.selected);

            this.showoverlay = true;
            let formData = new FormData();
            if(sltd.length>0 && this.selected)
            formData.append('employee_ids', this.selected);
            
            axios.post(this.$api_url+'/gf/export/add', formData)
            .then(function (response) 
            {                 
                this.showoverlay = false;                                                   
                //window.open(response.data);
                var fileURL = response.data;
                this.download_file(fileURL);
                
            }.bind(this))
            .catch(function (error) 
            {
                currentObj.errormsg = error.response.data.errors;
            });

        },

         
        
        addEmployeeToGf: function()
		{           
            if(this.chosen_emp_id && this.gf_approve_date){
            var curr_obj = this;
            
            let formData = new FormData();
            formData.append('emp_id', this.chosen_emp_id);
            formData.append('gf_start_date', this.gf_approve_date);
                    
		    axios.post(this.$api_url + '/gf/add-employee', formData)
            .then(function (response) 
            {
                if(response.data.success){
                    this.$bvToast.toast("Successfully added", {title: 'Success',variant: 'success',solid: true});
                    curr_obj.gf_start_date  = "";
                    this.gf_approve_date = '';
                    curr_obj.chosen_emp_id = 0;
                    curr_obj.users = [];
                    this.gfgetEmployees();
                }else if(response.data.errors){
                    this.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});  
                }
                this.$bvModal.hide('bv-modal-register-gf');
            }.bind(this))
            .catch(function (error) 
            {
                //curr_obj.errormsg = error.response.data.errors;
                console.log(error);
            }); 

		    }else{
		      this.$bvToast.toast("Please choose employee and enter GF start date", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
		    }

        },
         
        gfgetEmployees: function()
        {
            let currentObj = this;
            this.show_loader_3 = true;
            axios.get(this.$api_url+'/gf/allemployees' , {

            }).then(function(response)
            {
                /* Assingning the list */ 
                this.reg_tmp_custom_list = response.data.employee_data;
                /* Assingning the Options */ 
                this.reg_company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));
                this.reg_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));
                //this.reg_custom_list = this.reg_tmp_custom_list;
                this.reg_list_key = this.list_key + 1; 
                this.show_loader_3 = false;
                
            }.bind(this)).catch(function (error){currentObj.serverError(error);});
        },

        reg_listReturn:function(data)
        {
            if(data.selected.length > 0)
            {
                this.selected = data.selected;
            }
            else
            {
                this.selected = [];

            }

            if(data.employee_id && data.action_id==0)
            {
                this.getGfEmployeeData(data.employee_id);
                this.gf_approve_date = '';
                let asd = this.reg_custom_list;
                this.chosen_emp_id = data.employee_id;

                var item  = asd.find(item => item.employee_id === data.employee_id); 
                this.curr_emp_name = item.name;

                this.$bvModal.show('bv-modal-register-gf');

                //this.addEmployeeToGf(data.employee_id ,item)
            }

        },

            getGfEmployeeData:function(employee_id)
            {
                let formData = new FormData();
                formData.append('employee_id', employee_id);
                axios.post(this.$api_url + '/gf/get-employee-data', formData)
                .then(function (response) 
                {     
                    this.gf_profile_data = response.data.data;
                }.bind(this));
            },
        
            
    
            

        },
        created: function(){
            if(!this.checkNet()) return false;
        
            this.$validator.reset();

            this.gfgetEmployees();

        } 
    }
</script> 
